import styled from 'styled-components';

import { COLORS, HOME, SPACE } from '../../../../theme/tokens';
import { Text } from '../../../../components';

/** The overview card's notes button: the report button's outline, in the warning tone or the quiet one. */
export const Pill = styled.button<{ $warning: boolean }>`
  flex: none;
  display: inline-flex;
  align-items: center;
  gap: ${SPACE[8]};
  height: 40px;
  padding: ${SPACE[0]} ${SPACE[16]} ${SPACE[0]} ${SPACE[12]};
  color: ${({ $warning }) => ($warning ? COLORS.warning : HOME.t300)};
  border: 2px solid ${({ $warning }) => ($warning ? COLORS.warning : HOME.intervalBorder)};
  background: transparent;
  border-radius: 100px;
  font: inherit;
  font-size: 14px;
  font-weight: 600;
  white-space: nowrap;
  cursor: pointer;
`;

export const List = styled.ul`
  margin: ${SPACE[0]};
  padding: ${SPACE[0]};
  list-style: none;
  display: flex;
  flex-direction: column;
  gap: ${SPACE[12]};
`;

export const Item = styled.li`
  padding: ${SPACE[12]} ${SPACE[16]};
  border-radius: 12px;
  background: ${HOME.panel};
`;

export const NoteText = styled(Text)`
  margin: ${SPACE[0]};
  font-size: 14px;
  line-height: 1.5;
  color: ${HOME.t300};
`;
